<template>
  <v-container class="grey lighten-5">
    <v-row>
      <v-col cols="12">
        <div class="text-h5">{{ tituloPagina }}</div>
        <v-divider></v-divider>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="dadosTabela"
          sort-by="nome"
          :search="search"
          :custom-filter="filterOnlyCapsText"
        >i
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-col cols="5" class="pa-0">
                <v-text-field
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>

              <v-spacer></v-spacer>

              <v-dialog v-model="dialog" max-width="700px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="hidden-sm-and-down"
                    dark
                    color="blue"
                    right
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    novo
                  </v-btn>

                  <v-btn
                    class="hidden-md-and-up"
                    small
                    dark
                    fab
                    color="blue"
                    right
                    top
                    hide-details
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>

                <v-card>
                  <v-card-title>
                    <span class="headline">{{ tituloModal }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-divider></v-divider>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="10">
                          <v-text-field
                            v-model="editedItem.nome"
                            label="Nome do plano"
                            hide-details
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-select
                            :items="activeProductList"
                            v-model="editedItem.idResidencia"
                            label="Produto"
                            item-text="nome"
                            item-value="idResidencia"
                            hide-details
                          ></v-select>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-select
                            :items="itPeriodicidade"
                            v-model="editedItem.periodicidade"
                            label="Periodicidade"
                            item-text="descricao"
                            hide-details
                          ></v-select>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-select
                            :items="itStatus"
                            v-model="editedItem.status"
                            label="Status"
                            item-text="descricao"
                            hide-details
                          ></v-select>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.valorBoleto"
                            label="Valor boleto"
                            prefix="R$"
                            type="decimal"
                            hide-details
                          ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.valorCartao"
                            label="Valor cartão"
                            prefix="R$"
                            hide-details
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="editedItem.limiteParcelas"
                            label="Limite parcelas"
                            hide-details
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="4">
                          <v-text-field
                            v-model="editedItem.idPlanoEduzz"
                            label="Código Eduzz"
                            hide-details @keypress="isNumber($event)"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close"
                      >Cancelar</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="salvar"
                      >Salvar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:[`item.acao`]="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon
            >
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Headers from "../../components/jsonsHelper/headers.json";
import Util from "../../services/utils";
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    tituloPagina: "",
    headers: [],
    search: "",
    dialog: false,
    itStatus: "",
    itPeriodicidade: "",
    dadosTabela: [],
    editedIndex: -1,
    editedItem: {
      nome: "",
      idResidencia: "",
      periodicidade: "",
      valorBoleto: "",
      valorCartao: "",
      limiteParcelas: "",
      status: "",
      idPlanoEduzz: ""
    },
    defaultItem: {
      nome: "",
      idResidencia: "",
      periodicidade: "",
      valorBoleto: "",
      valorCartao: "",
      limiteParcelas: "",
      status: "",
      idPlanoEduzz: ""
    },
  }),

  computed: {
    ...mapState("plan", ["planList"]),
    ...mapState("product", ["activeProductList"]),
    tituloModal() {
      return this.editedIndex === -1 ? "Novo Plano" : "Editar Plano";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions("plan", [
      "getPlanList",
      "deletePlan",
      "createNewPlan",
      "changePlanData",
    ]),
    ...mapActions("product", ["getProductListActive"]),
    async initialize() {
      await this.getPlanList();
      await this.getProductListActive();
      this.headers = Headers.planoHeaders;
      this.tituloPagina = "Cadastro plano de acesso";
      this.dadosTabela = [...this.planList];
    },

    filterOnlyCapsText(value, search) {
      search = search.toString().toLocaleUpperCase();
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      );
    },

    editItem(item) {
      this.editedIndex = this.dadosTabela.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.dadosTabela.indexOf(item);
      confirm(
        "Tem certeza que deseja excluir este registro definitivamente? (Esta ação não poderá ser desfeita)"
      ) &&
        this.deletePlan(item.idPlano).then((status) => {
          status === 200 && this.dadosTabela.splice(index, 1);
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      })
    },

    salvar() {
      if (this.editedIndex > -1) {
        this.changePlanData(this.editedItem).then((status) => {
          status === 200;
          Object.assign(this.dadosTabela[this.editedIndex], this.editedItem);
          this.close();
        });
      } else {
        this.createNewPlan(this.editedItem).then((status) => {
          this.dadosTabela.push(this.editedItem);
          status === 200;
          this.close();
        });
      }
    },

    isNumber: function(evt) {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();
        } else {
          return true;
        }
      }
  },
  mounted() {
    Util.getPeriodicidade().then((resposta) => {
      this.itPeriodicidade = resposta.data;
    }),
      Util.getStatus().then((resposta) => {
        this.itStatus = resposta.data;
      });
  },
};
</script>
